import socketio from 'socket.io-client';
import console from 'console';

export default {
    methods: {
        initSocket() {
            if (this.$store.state.user) {
                if (this.$socket) {
                    this.$socket.disconnect();
                    this.$socket = null;
                }
                this.$socket = socketio(process.env.VUE_APP_WS_SERVER + '/admin', { transports: ['websocket'] });
                this.$socket.on('connect', () => {
                    this.$socket.emit('authenticate', { token: this.$store.state.token });
                    console.log('Socket connected')
                });
                this.$socket.on('disconnect', () => {
                    console.log('Socket disconnected')
                });

                this.$socket.on('importCompleted', (data) => {
                    this.$swal({
                        title: this.$t('importCompleted', [data.fileName, this.$t(data.target)]),
                        icon: 'success',
                        toast: true,
                        position: 'bottom-end',
                        timer: 5000,
                    }).then(() => {
                        if (data.target === 'call-campaign-contact' || data.target === 'campaign-contact-del') {
                            this.$bus.$emit('reLoadCallCampaignContact');
                        } else {
                            this.$bus.$emit('reloadContact');
                        }
                    });
                });

                this.$socket.on('exportCompleted', (data) => {
                    this.$bus.$emit('loadExportExcel');
                    this.$swal({
                        title: this.$t('exportCompleted', [this.$t(data.source)]),
                        confirmButtonText: this.$t('download'),
                        icon: 'success',
                        toast: true,
                        position: 'bottom-end',
                        timer: 10000,
                    }).then(() => {
                        window.open(data.url, '_blank');
                    });
                });

                this.$socket.on('creditDepositConfirmed', (data) => {
                    this.$bus.$emit('creditDepositConfirmed', data);
                });
            }
        },
        closeSocket() {
            if (this.$socket) {
                this.$socket.disconnect();
                this.$socket = null;
            }
        }
    },
    mounted() {
        this.initSocket();
        this.$bus.$on('initSocket', this.initSocket);
        this.$bus.$on('closeSocket', this.closeSocket);
    },
    beforeDestroy() {
        this.closeSocket();
        this.$bus.$off('initSocket');
        this.$bus.$off('closeSocket');
    },
    i18n: {
        messages: {
            en: {
                importCompleted: 'Import {1} from excel finished!',
                exportCompleted: 'Export {0} completed!',
                download: 'Download'
            },
            vi: {
                importCompleted: 'Nhập {1} từ excel hoàn tất!',
                exportCompleted: 'Xuất {0} đã hoàn tất!',
                download: 'Tải về'
            }
        }
    }
}